// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__EZa21","loader_container":"loader_loader_container__oPcq1","animloader":"loader_animloader__nHCY4"};